{
    "coordinates": [
        -13.797257278029576,
        -76.08747925604533
    ],
    "tooltip": "Pisco",
    "title": "Pisco Formation",
    "country": "Peru",
    "period": "Neogene"
}
